import { render, staticRenderFns } from "./ModalWelcomeTrialPremium.vue?vue&type=template&id=40bfedd7&"
import script from "./ModalWelcomeTrialPremium.vue?vue&type=script&lang=js&"
export * from "./ModalWelcomeTrialPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports